import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { useTranslations } from 'next-intl';

import { $apiV2, errorHandler } from 'modules/global';

export const useSendSmsV2 = () => {
  const t = useTranslations();

  return useMutation({
    mutationFn: async (phone?: string) => {
      const { data } = await $apiV2.post('/auth/send-sms', { phone });

      return data;
    },
    onSuccess: () => {
      message.success(t('tasdiqlash_kodi_jonatildi'));
    },
    onError: errorHandler()
  });
};
